import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const ACCESS_KEY = "amden_access";
const REFRESH_KEY = "amden_refresh";
// Per-tab impersonation token (read-only client view). Kept in sessionStorage so it
// NEVER touches or replaces the Super Admin's own localStorage session in other tabs.
const IMP_KEY = "amden_imp_access";

export function setTokens(access, refresh) {
  if (access) localStorage.setItem(ACCESS_KEY, access);
  if (refresh) localStorage.setItem(REFRESH_KEY, refresh);
}
export function clearTokens() {
  localStorage.removeItem(ACCESS_KEY);
  localStorage.removeItem(REFRESH_KEY);
}
export function isImpersonating() { return !!sessionStorage.getItem(IMP_KEY); }
export function setImpersonationToken(t) { if (t) sessionStorage.setItem(IMP_KEY, t); }
export function clearImpersonation() { sessionStorage.removeItem(IMP_KEY); }
export function getAccess() { return sessionStorage.getItem(IMP_KEY) || localStorage.getItem(ACCESS_KEY); }

const api = axios.create({ baseURL: API_BASE, withCredentials: true });

api.interceptors.request.use((config) => {
  const t = getAccess();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

let refreshing = null;
api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const original = error.config;
    if (error.response?.status === 401 && !original._retry && !original.url.includes("/auth/")) {
      // Impersonation tab: never refresh (no refresh token) and never touch the
      // admin's localStorage — just drop the read-only session.
      if (isImpersonating()) { clearImpersonation(); return Promise.reject(error); }
      original._retry = true;
      try {
        refreshing = refreshing || api.post("/auth/refresh", { refresh_token: localStorage.getItem(REFRESH_KEY) });
        const { data } = await refreshing;
        refreshing = null;
        if (data?.access_token) localStorage.setItem(ACCESS_KEY, data.access_token);
        return api(original);
      } catch (e) {
        refreshing = null;
        clearTokens();
      }
    }
    return Promise.reject(error);
  }
);

export function apiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
